import { capabilities } from 'navigation-components/capabilities';
import { useCapability } from 'navigation-components/platform/hooks';
import { useEffect, useState } from 'react';
import { captureException } from 'unified-navigation-ui/utils/sentryAPI';
import { getUnreadCount } from '../../api/notificationsApi';
import isNotificationsDisable from '../../utils/isNotificationsDisable';
import { UnseenCountContext } from './UnseenCountContext';
// @ts-expect-error bender imports are untyped
import defaultFaviconUrl from 'bender-url!unified-navigation-ui/resources/default_favicon.ico';
// @ts-expect-error bender imports are untyped
import newNotificationFaviconUrl from 'bender-url!unified-navigation-ui/resources/fav-icon-red-big.ico';
import { jsx as _jsx } from "react/jsx-runtime";
const safeGetParentDocument = () => {
  if (!window.top) {
    return;
  }
  try {
    return window.top.document;
  } catch (e) {
    // In cross-origin scenario accessing document will throw
    return;
  }
};
const setNewFavIcon = showDot => {
  const parentDocument = safeGetParentDocument();
  if (!parentDocument) {
    return;
  }
  const link = parentDocument.createElement('link');
  link.id = 'dynamic-favicon';
  link.rel = 'shortcut icon';
  link.href = showDot ? newNotificationFaviconUrl : defaultFaviconUrl;
  parentDocument.head.appendChild(link);
};
export const NavComponentsUnseenCountProvider = ({
  children
}) => {
  const [unseenCount, setUnseenCount] = useState(undefined);
  const {
    subscribe: subscribeToBellIconCount
  } = useCapability(capabilities.UPDATE_BELL_ICON_COUNT_CAP.getName());
  useEffect(() => {
    let mounted = true;
    if (isNotificationsDisable()) {
      return;
    }
    getUnreadCount().then(response => response.counter).then(count => {
      if (mounted) {
        setUnseenCount(presentCount => presentCount === undefined ? count : presentCount);
        if (count > 0) {
          // It's okay that we never set this to 'false' in this nav repo. Clicking the bell
          // will open the notifications nav component which will then manage the favicon
          // state (it's impossible to clear the indicator without opening the menu first)
          setNewFavIcon(true);
        }
      }
    }).catch(captureException);
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    return subscribeToBellIconCount(countChange => {
      setUnseenCount(countChange.count);
    });
  }, [subscribeToBellIconCount]);
  return /*#__PURE__*/_jsx(UnseenCountContext.Provider, {
    value: unseenCount || 0,
    children: children
  });
};